import { MRT_ColumnDef } from 'material-react-table';
import { IBlockListProps } from '../../eligibility/eligibility-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { getFormattedDate } from '../../../utils/utilities';

export enum BlockListTableAccessorKeys {
	type = 'fingerprintType',
	meta = 'meta',
	validUntil = 'validUntil',
	reason = 'reason',
}

export const defaultBlockListColumns: MRT_ColumnDef<IBlockListProps>[] = [
	{
		accessorKey: BlockListTableAccessorKeys.type,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7 ms-3"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</ TableCell>
		)
	},
	{
		accessorKey: BlockListTableAccessorKeys.meta,
		header: 'Meta',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Meta</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7 ms-3"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</ TableCell>
		)
	},
	{
		accessorKey: BlockListTableAccessorKeys.validUntil,
		header: 'Block until',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Block until</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7 ms-3"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? getFormattedDate(renderedCellValue, 'dd MMM, yyyy') : '-'}
			</ TableCell>
		)
	},
	{
		accessorKey: BlockListTableAccessorKeys.reason,
		header: 'Block reason',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Block reason</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7 ms-3"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</ TableCell>
		)
	},
];
